import Wizard from "../../Components/Wizard/Wizard";  
import FeasibilitySummaryModal from "./FeasibilitySummaryModal";
import RequiredMaterialsModal from "./RequiredMaterialsModal";
import { Get, Post, Put } from "../../Services/Server";
import Url from "../../Services/Url";
import { toast } from "react-toastify";
import User from "../../Services/User";
import { useEffect, useState } from "react";

const CreateReportWizard = ({ children }) => {
  const { closeModal, survey } = children;
  const [initialReport, setInitialReport] = useState(null);

  // Fetch existing report by job on mount
  useEffect(() => {
    Get(Url.survey.getReportByJobId(survey.jobNumber))
      .then((resp) => {
        if (resp) {
          const parsedReport = {
            FeasibilitySummaryModal: {
              feasibilitySummary: resp.description,
              docId: resp.docId,
            },
            RequiredMaterialsModal: {
              equipments: JSON.parse(resp.equipments || "[]"),
            },
            id: resp.id,  };
          setInitialReport(parsedReport);
        }
      })
      .catch((err) => console.error("Error fetching existing report:", err));
  }, [survey.jobNumber]);

  const handleSubmitFinal = (reportData) => {
    const payload = {
      jobId: survey.jobNumber,
      surveyId: survey.id,
      description: reportData.FeasibilitySummaryModal?.feasibilitySummary,
      docId: reportData.FeasibilitySummaryModal?.docId,
      createdBy: User.getBiodata().id,
      equipment: reportData.RequiredMaterialsModal?.equipments,
    };

    const request = initialReport
      ? Put(Url.survey.updateReport(initialReport.id), payload)
      : Post(Url.survey.createReport, payload);

    request
      .then((resp) => {
        toast(initialReport ? "Report updated" : "Report created");
        closeModal(resp);
      })
      .catch((err) => {
        console.error("Error submitting report:", err);
        toast("Failed to submit report");
      });
  };

  const pages = [
    (props) => (
      <FeasibilitySummaryModal
        {...props}
        survey={survey}
        children={children}
        initial={initialReport}
        onNext={(data) => {
          children.FeasibilitySummaryModal = data;
          props.onNext();
        }}
      />
    ),
    (props) => (
      <RequiredMaterialsModal
        {...props}
        survey={survey}
        children={children}
        initial={initialReport}
        onNext={(data) => {
          children.RequiredMaterialsModal = data;
          handleSubmitFinal(children);
        }}
      />
    ),
  ];

  return (
    <Wizard width={500} onClose={closeModal} survey={survey}>
      {pages}
    </Wizard>
  );
};

export default CreateReportWizard;
